exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#printable table tr.cobrado {\n  color: green; }\n\n#printable table tr.cancelado {\n  color: red; }\n\n@media print {\n  #td-select {\n    display: none; }\n  #printable {\n    overflow: visible !important;\n    top: 15px;\n    left: 15px;\n    right: 15px;\n    bottom: 15px; }\n    #printable * {\n      font-size: 11px;\n      float: none !important;\n      position: relative !important;\n      visibility: visible; }\n    #printable h1, #printable h2, #printable h3 {\n      display: inline-block; }\n    #printable table {\n      width: 100% !important; }\n      #printable table tr {\n        width: 100% !important; }\n    #printable h2 {\n      font-size: 18px;\n      text-decoration: underline; }\n    #printable h3 {\n      font-size: 16px;\n      text-decoration: underline; }\n    #printable .no-print {\n      display: none; }\n    #printable .invisible {\n      visibility: visible !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/home/turnos-dados/turnos-dados.component.scss
// module id = ../../../../../src/app/home/turnos-dados/turnos-dados.component.scss
// module chunks = 1